export default "__VITE_ASSET__BXvJ3Hko__"